import React from "react";
import { useTranslation } from "react-i18next";
import { SocialProofText } from "../../../Constants";
import SocialProofImg from "../../../assets/SocialProof.webp";
import Stars from "../../../assets/stars-2.webp";
const SocialProof = ({ totalReviews, averageReviews, onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      className="t-flex t-items-center t-gap-2  t-p-2 t-rounded-lg"
      onClick={onClick}
    >
      <img src={SocialProofImg} alt="SocialProof" className="t-w-16" />
      <img src={Stars} alt="" height={80} width={80} className="t-h-4 t-w-20" />
      <p className="t-m-0 t-font-extrabold" style={{ fontFamily: "Roboto" }}>
        {averageReviews}/5 ({totalReviews})
      </p>
    </div>
  );
};

export default SocialProof;
